import { configure } from '@js-boot/logger'
import { Logger, LogLevelDesc } from 'loglevel'
import { DatadogFactory } from '../datadog/datadog'

// Needed to serialize the error as json when sending to the LOG_HTTP_SINK

const { getLogger } = configure({
  level: (process.env.LOG_LEVEL as LogLevelDesc) ?? 'info',
  http: process.env.LOG_HTTP_SINK ? { url: process.env.LOG_HTTP_SINK } : undefined,
  console: process.env.DEVELOPMENT_TYPE === 'local' ? { enabled: true } : undefined,
})

function getCLSLogger(name: string): Logger {
  const logger = getLogger(`CentralListing${name}`)
  return new Proxy(logger, {
    get: function (target, propKey) {
      // @ts-ignore
      const origMethod = target[propKey]

      if (typeof origMethod === 'function' && (propKey === 'error' || propKey === 'warn')) {
        return function (...args: any[]) {
          DatadogFactory.addError(new Error(JSON.stringify(args)))
          // @ts-ignore
          return origMethod.apply(this, args)
        }
      } else {
        return origMethod
      }
    },
  })
}

function getCLSDefaultLogger(): Logger {
  return getCLSLogger('Default')
}

export { getCLSLogger as getLogger, getCLSDefaultLogger as getDefaultLogger }
